import { Plus, Trash2, MessageSquare } from 'lucide-react';
import { useBrain } from '../../contexts/BrainContext';

export function ThreadList() {
  const { threads, activeThreadId, openThread, newThread, removeThread, pending } = useBrain();

  return (
    <aside className="flex h-full w-56 flex-col border-r border-white/10 bg-neutral-950/50">
      <div className="flex items-center justify-between border-b border-white/10 px-3 py-2.5">
        <span className="text-[10px] font-semibold uppercase tracking-widest text-neutral-500">History</span>
        <button
          type="button"
          onClick={newThread}
          disabled={pending}
          className="flex items-center gap-1 rounded-md border border-white/10 bg-white/[0.04] px-2 py-1 text-[11px] font-medium text-neutral-200 transition hover:bg-white/[0.08] disabled:opacity-50"
          title="New chat"
        >
          <Plus className="h-3 w-3" /> New
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-2 py-2">
        {threads.length === 0 ? (
          <p className="px-2 py-3 text-[11px] text-neutral-500">No saved threads yet.</p>
        ) : (
          <ul className="flex flex-col gap-0.5">
            {threads.map((t) => (
              <li key={t.id} className="group">
                <div
                  className={`flex items-center gap-1.5 rounded-md px-2 py-1.5 transition ${
                    activeThreadId === t.id
                      ? 'bg-brand-500/15 text-brand-100'
                      : 'text-neutral-300 hover:bg-white/5'
                  }`}
                >
                  <MessageSquare className="h-3 w-3 flex-shrink-0 text-neutral-500" />
                  <button
                    type="button"
                    onClick={() => openThread(t.id)}
                    className="flex-1 truncate text-left text-[12px]"
                    title={t.title ?? 'Untitled thread'}
                  >
                    {t.title ?? 'Untitled'}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      if (confirm('Delete this thread?')) removeThread(t.id);
                    }}
                    className="opacity-0 transition group-hover:opacity-100"
                    title="Delete"
                  >
                    <Trash2 className="h-3 w-3 text-neutral-500 hover:text-red-400" />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </aside>
  );
}
